import React from "react";
import { Helmet } from "react-helmet-async";
import PageWrapper from "../components/PageWrapper";
import SekcjaKontakt from "../components/SekcjaKontakt";

export default function Kontakt() {
  return (
    <PageWrapper>
      <Helmet>
        <title>Kontakt – DJ Kusy</title>
        <meta
          name="description"
          content="Chcesz, by Twoja impreza była niezapomniana? Skontaktuj się z DJ Kusym – zapytaj o wolny termin, indywidualną ofertę i spraw, by Twoje wydarzenie było wyjątkowe! Szybka odpowiedź i pełne wsparcie."
        />
        <link rel="canonical" href="https://djkusy.pl/kontakt" />
        <meta property="og:title" content="DJ Kusy – Kontakt" />
        <meta property="og:description" content="Formularz kontaktowy, dane, e-mail i numer telefonu do DJ Kusego. Zapytaj o termin i dostępność!" />
        <meta property="og:image" content="https://djkusy.pl/og-image.webp" />
        <meta property="og:url" content="https://djkusy.pl/kontakt" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Breadcrumbs structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Strona główna",
                "item": "https://djkusy.pl/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Kontakt",
                "item": "https://djkusy.pl/kontakt"
              }
            ]
          })}
        </script>

        {/* WebPage structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Kontakt",
            "url": "https://djkusy.pl/kontakt",
            "description": "Kontakt do DJ-a: zapytaj o wolny termin, ofertę, rezerwację lub szczegóły imprezy. Formularz, telefon, e-mail.",
            "inLanguage": "pl-PL"
          })}
        </script>
      </Helmet>

      <section
        id="hero"
        className="min-h-[70vh] bg-cover bg-center relative flex items-center justify-center text-white text-center px-4"
        style={{ backgroundImage: "url('/assets/otwarte/otwarte7.webp')" }}
      >
        <div className="absolute inset-0 bg-black opacity-60" />
        <div className="relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Kontakt</h1>
          <p className="text-lg text-gray-300 max-w-xl mx-auto">
            Masz pytanie lub chcesz zarezerwować termin? Napisz lub zadzwoń!
          </p>
        </div>
      </section>
<SekcjaKontakt/>
    </PageWrapper>
  );
}
